module.exports = __webpack_public_path__ + "img/icon-blank-red.baa52fb9.svg";